import { useRouter } from 'next/router';
import RegisterBox from '../../RegisterBox';
import CardList from './CardList';
import Programme from './Programme';
import ScrollCard from './ScrollCard';
import EarnMore from './EarnMore';
import UseSpecials from './UseSpecials';
import { MUTI_AREA_ARR } from '@/componentsH5/EcoCreditsDay/components/AnchorTabs/constant';

export default function TabB() {
    const { locale } = useRouter();

    return (
        <>
            {['jp'].includes(locale as string) && <CardList />}
            <Programme />
            <ScrollCard />
            {!MUTI_AREA_ARR.includes(locale as string) && <EarnMore />}
            {/* <EarnMore /> */}
            {!MUTI_AREA_ARR.includes(locale as string) && <UseSpecials />}
            {/* <UseSpecials /> */}
            {['kr'].includes(locale as string) && <RegisterBox />}
        </>
    );
}
